import ApiService from "./api.service";
import { LOAD_PROPERTIES } from "../store/property.module";

const ConfigService = {
  store: null,
  alreadyLoaded: false,

  init(opts) {
    if (opts.store) {
      this.store = opts.store;
    }
  },

  get(key) {
    if (!this.alreadyLoaded) {
      console.error("Cannot access properties: not yet loaded");
      throw new Error("Cannot access properties: not yet loaded");
    }
    let properties = this.store.getters.properties;
    return properties.find(p => p.key === key)?.value;
  },

  async loadKeysForSelectedClient() {
    let response = await ApiService.get("/api/properties/bySelectedClient/public");
    let properties = response.data;
    this.store.dispatch(LOAD_PROPERTIES, properties);
    this.alreadyLoaded = true;
  }
};

export default ConfigService;
